import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import EventSeatRoundedIcon from "@mui/icons-material/EventSeatRounded";
import { publicReservationSettings } from "../../apollo/server";
import { C, FONT_BODY, RADIUS } from "../../utils/designTokens";

const SETTINGS = gql`${publicReservationSettings}`;

/**
 * "Reserve a table" on a restaurant's page. Renders nothing unless the
 * restaurant takes bookings online. It runs its own small query so the cached
 * restaurant and menu response is never touched, and a failure just hides it.
 */
export default function ReserveTableButton({ restaurantId, slug }) {
  const navigate = useNavigate();
  const { data } = useQuery(SETTINGS, {
    variables: { restaurantId },
    skip: !restaurantId || !slug,
    fetchPolicy: "cache-first",
  });

  if (!data?.publicReservationSettings?.enabled) return null;

  return (
    <Button
      variant="contained"
      disableElevation
      startIcon={<EventSeatRoundedIcon />}
      onClick={() => navigate(`/reserve/${slug}`)}
      sx={{
        textTransform: "none",
        height: 44,
        px: 2,
        borderRadius: RADIUS.control,
        fontFamily: FONT_BODY,
        fontSize: 14,
        fontWeight: 700,
        whiteSpace: "nowrap",
        bgcolor: C.red,
        "&:hover": { bgcolor: C.redHover },
        "&:focus-visible": { outline: `2px solid ${C.ink}`, outlineOffset: 2 },
      }}
    >
      Reserve a table
    </Button>
  );
}
